import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { withRouter } from "react-router"

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

import TablePaginationActions from '../common/TablePaginationActions'
import NoDataRow from '../common/NoDataRow'

import { formatNumber, formatDate, PAGE_SIZE } from 'libraries/utils'

import { getOrderList } from '../../actions/asyncOrders'

const TabEnum = {
    0: 'all',
    1: 'status-unpaid',
    2: 'serviceAction-inbound',
    3: 'serviceAction-outbound',
    4: 'serviceAction-storage',
}

class OrderList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: props.location.state || 0,
            page: 0,
        }
    }

    componentDidMount() {
        this.getOrderList()
    }

    onClickTab = (event, activeTab) => {
        if(activeTab !== this.state.activeTab) {
            this.setState({
                activeTab,
                page: 0
            }, () => {
                this.getOrderList()
            })
        }
    }

    handleChangePage = (newPage) => {
        this.setState({ page: newPage }, () => {
            this.getOrderList()
        })
    }

    getOrderList = () => {
        const { activeTab, page } = this.state
        let query = {}
        if(activeTab !== 0){
            const [name, value] = TabEnum[activeTab].split('-')
            query = {
                [name]: value
            }
        }
        this.props.getOrderList(query, page + 1, PAGE_SIZE) // query, page, perPage
    }

    onClickRow = (orderId) => {
        this.props.history.push('/member/order/detail', orderId)
    }

    getStatusColor = (status) => {
        switch (status) {
            case 'paid':
                return 'primary'
            case 'payment_failed':
            case 'expired':
                return 'error'
            case 'unpaid':
                return 'textSecondary'
            default:
                return 'textSecondary'
        }
    }

    render() {
        const { t } = this.props
        const { activeTab, page } = this.state
        const { list, pagination } = this.props.orderList

        return (
            <Grid container justify="center" className="order-list">
                <Grid item md={8}>
                    <Grid container alignItems="baseline">
                        <Typography variant="h1">{t('order_list')}</Typography>
                        <Typography style={{ marginLeft: '10px' }}>{t('order_list_tip')}</Typography>
                    </Grid>
                    <Tabs
                        value={activeTab}
                        onChange={this.onClickTab}
                        className="tabs"
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab label={t('order_all')} />
                        <Tab label={t('order_unpaid')} />
                        <Tab label={t('service_action_inbound')} />
                        <Tab label={t('service_action_outbound')} />
                        <Tab label={t('service_action_storage')} />
                    </Tabs>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ paddingLeft: '30px' }}>{t('date')}</TableCell>
                                <TableCell>{t('order_number')}</TableCell>
                                <TableCell>{t('service_action')}</TableCell>
                                <TableCell>{t('bottle_number')}</TableCell>
                                <TableCell>{t('price')}</TableCell>
                                <TableCell>{t('status')}</TableCell>
                            </TableRow>
                        </TableHead>
                        {
                            list.length === 0
                            ?
                            <TableBody>
                                <NoDataRow colSpan={6} />
                            </TableBody>
                            :
                            <Fragment>
                                <TableBody>
                                    {list.map(item => {
                                        const createDate = formatDate(item.createdAt)
                                        const serviceAction = t(`service_action_${item.serviceAction}`)
                                        const amount = formatNumber(item.amount)
                                        const paymentStatus = item.paymentStatus
                                        const paymentStatusTxt = t(`payment_status_${item.paymentStatus}`)
                                        const statusColor = this.getStatusColor(paymentStatus)
                                        return (
                                            <TableRow
                                                hover
                                                key={item.id}
                                                onClick={() => this.onClickRow(item.id)}
                                                className="pointer"
                                            >
                                                <TableCell style={{ paddingLeft: '30px' }}>{createDate}</TableCell>
                                                <TableCell>{item.orderNo}</TableCell>
                                                <TableCell>{serviceAction}</TableCell>
                                                <TableCell>{item.totalBottle}</TableCell>
                                                <TableCell>$ {amount}</TableCell>
                                                <TableCell>
                                                    <Typography color={statusColor}>
                                                        {paymentStatusTxt}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            className="pagination"
                                            rowsPerPageOptions={[]}
                                            labelDisplayedRows={() => null}
                                            count={pagination.totalCount}
                                            rowsPerPage={PAGE_SIZE}
                                            page={page}
                                            onChangePage={this.handleChangePage}
                                            ActionsComponent={TablePaginationActions}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Fragment>
                        }
                    </Table>
                </Grid>
            </Grid>
        )
    }
}

const mapStateToProps = state => ({
    orderList: state.orders.orderList
})

const mapDispatchToProps = {
    getOrderList
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(withTranslation()(OrderList)))